export var getOrgUnitInfo = function getOrgUnitInfo() {
  return JSON.parse(sessionStorage.getItem('CUR_UNIT') || '{}');
};